/* eslint-disable no-console */
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Websocket from 'react-websocket';
import { isMobile } from 'react-device-detect';

import { newWebsocketMessage } from './actions';
import {EVENT_WEBSOCKET_CONNECTION_LOST, segmentTrack} from '../layout/helper';
import { getTickets } from '../tickets/actions';

export default () => {
    const dispatch = useDispatch();
    const wsUrl = localStorage.getItem('iot_rocket_websocket_url');
    const currentUser = useSelector(state => state.users.currentUser);
    const filter_admin_on_skills = useSelector(state => state.workspace.settings.filter_admin_on_skills);
    const filter_user_on_skills = useSelector(state => state.workspace.settings.filter_user_on_skills);
    const user_tickets_mode = useSelector(state => state.workspace.settings.user_tickets_mode);
    const contractor_tickets_mode = useSelector(state => state.workspace.settings.contractor_tickets_mode);
    const groupList = useSelector(state => state.groups.list);
    const ticketsActiveMode = useSelector(state => state.tickets.list.find(category => category?.id === 'ARCHIVED')?.isVisible === false);
    const workspaceWebsocket = useRef(null);
    const notificationWebsocket = useRef(null);

    // The websocket server only subscribes the connection once it receives a valid access token as first message.
    // Sent on every (re)connection, with the current token since it is refreshed over time.
    const authenticate = websocket => websocket.current?.sendMessage(JSON.stringify({
        type: 'auth',
        token: localStorage.getItem('iot_rocket_access_JWT')
    }));

    if (!wsUrl) return null;
    if (currentUser && currentUser.id && localStorage.getItem('iot_rocket_workspace') !== 'zeop') {
        return (
            <>
                <Websocket
                    ref={workspaceWebsocket}
                    url={wsUrl}
                    onMessage={msg => {
                        const data = JSON.parse(msg);
                        if (data.type === 'auth_ok') return;
                        dispatch(newWebsocketMessage({
                            message_type: data.message_type,
                            message_data: JSON.parse(
                                data.message_data
                            ),
                            message_author: data.message_author
                        }, currentUser, filter_admin_on_skills, filter_user_on_skills, user_tickets_mode, groupList, contractor_tickets_mode));
                    }}
                    onOpen={() => {
                        authenticate(workspaceWebsocket);
                        console.log('Connection to workspace websocket successfull');
                    }}
                    onClose={() => {
                        segmentTrack(EVENT_WEBSOCKET_CONNECTION_LOST, { userMail: currentUser.email });
                        console.error('Connection to workspace websocket lost');
                        if ((localStorage.getItem('iot_rocket_workspace') === 'elise'
                            || localStorage.getItem('iot_rocket_workspace') === 'nxp')
                            && !isMobile) {
                            dispatch(getTickets(ticketsActiveMode, 'my_tickets'));
                        }
                    }}
                />
                <Websocket
                    ref={notificationWebsocket}
                    url={wsUrl.concat(currentUser.id, '/')}
                    onMessage={msg => {
                        const data = JSON.parse(msg);
                        if (data.type === 'auth_ok') return;
                        dispatch(newWebsocketMessage({
                            message_type: data.message_type,
                            message_data: JSON.parse(
                                data.message_data
                            ),
                            message_author: data.message_author
                        }, currentUser, filter_admin_on_skills, filter_user_on_skills, user_tickets_mode, groupList, contractor_tickets_mode));
                    }}
                    onOpen={() => {
                        authenticate(notificationWebsocket);
                        console.log('Connection to notification websocket successfull');
                    }}
                    onClose={() => console.error('Connection to notification websocket lost')}
                />
            </>
        );
    } else {
        return null
    }

};
